<template>
  <form @submit.prevent="submit">
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">ADD AUX</p>
      </header>
      <section class="modal-card-body">
        <b-field label="Type">
          <b-taginput
              v-model="data.type"
              :data="filteredTypeList"
              autocomplete
              :allow-new="true"
              :open-on-focus="false"
              icon="label"
              placeholder="Add a type"
              maxtags="1"
              @typing="getFilteredTypes"
          >
              <template slot-scope="props">{{props.option}}</template>
              <template slot="empty">No Result</template>
          </b-taginput>
        </b-field>
        <b-field label="Value">
          <input type="text" class="input" v-model="data.value">
        </b-field>
      </section>
      <footer class="modal-card-foot">
        <button class="button" type="button" @click="$parent.close()">Close</button>
        <button class="button is-primary" :disabled="loading">Save</button>
      </footer>
    </div>
  </form>
</template>
<script>
import { OrderService } from "@/services/order.service";
import { TagService } from "@/services/tag.service";
import { AttributeService } from "@/services/attributes.service";
import { JsonDenormalizer } from "@/helpers/JsonDenormalizer";
import debounce from "lodash/debounce";

export default {
  data: () => ({
    tagService: TagService,
    orderService: OrderService,
    attributeService: AttributeService,
    types: [],
    filteredTypeList: [],
    data: {
      type: null,
      value: null
    },
    loading: false
  }),
  props: {
    order: {
      type: Object,
      required: true
    },
  },
  created(){
    this.getTypes();
  },
  methods: {
    async submit() {
      this.loading = true;
      let data = {
          type : this.data.type[0], 
          value: this.data.value,
          includes: 'attributes'
        }

      let response = await this.orderService
          .addAttribute(this.order.id, data)
          .then(response => JsonDenormalizer.denormalize(response));

      this.$parent.close();
      this.$buefy.toast.open({
        message: "New AUX data was saved.",
        type: "is-success",
        position: "is-top-right"
      });
      this.order.attributes = response.attributes

      this.loading = false;


      // this.orderService.addAttribute(this.order.id, data)
      // .then(response => {
      //   this.$parent.close();
      //   this.$buefy.toast.open({
      //     message: "New AUX data was saved.",
      //     type: "is-success",
      //     position: "is-top-right"
      //   });

      //   this.order.aux_data = response.data.data.attributes.aux_data
      // })
      // .catch(() => {
      //     // AJAX interceptor should have handled this.
      // })
      // .finally(() => {
      //     this.loading = false;
      // });
    },
    async getTypes() {
          this.types = await this.attributeService
              .all({code: 'order'})
              .then(response => JsonDenormalizer.denormalize(response));
    },
    getFilteredTypes: debounce(function(filter) {
        this.filteredTypeList = this.types
            .filter(option => {
                return (
                    option.name
                        .toString()
                        .toLowerCase()
                        .indexOf(filter.toLowerCase()) >= 0
                );
            })
            .map(type => type.name);
    }, 200),
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Order/OrderAuxModal.vue